import { render } from "./newsSection.vue?vue&type=template&id=1d8b0de7&scoped=true"
import script from "./newsSection.vue?vue&type=script&lang=js"
export * from "./newsSection.vue?vue&type=script&lang=js"

import "./newsSection.vue?vue&type=style&index=0&id=1d8b0de7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8b0de7"]])

export default __exports__